/**
 *
 * ApexOnlineMenuData Service Selectors
 *
 */

import { createSelector } from 'reselect';
import { NAMESPACE } from './constants';

var legacyUrl = function legacyUrl(state) {
  return state[NAMESPACE] || {};
};

var legacyUrlResults = createSelector(legacyUrl, function (state) {
  return state && state.legacyUrl;
});
var legacyUrlError = createSelector(legacyUrl, function (state) {
  return state && state.error;
});

export { legacyUrlResults, legacyUrlError };